import { useContext, useMemo, useEffect } from 'react';
import { GlobalOptionsFetchingContext } from '../context';

export const useGlobalOptionsFetchingContext = () => {
  const context = useContext(GlobalOptionsFetchingContext);
  if (!context)
    throw new Error('useGlobalOptionsFetchingContext must be used inside the GlobalOptionsFetchingProvider');
  return useMemo(() => context, [context]);
};
export const useGlobalFieldOptions = ({ statusPrefix, variableNames }: ContextProps) => {
  const { fetchVariable, fetchStatus } = useGlobalOptionsFetchingContext();
  useEffect(() => {
    if (variableNames) fetchVariable(variableNames);
  }, [variableNames]);
  useEffect(() => {
    if (statusPrefix) fetchStatus(statusPrefix);
  }, [statusPrefix]);
  return null;
};
export default useGlobalOptionsFetchingContext;
type ContextProps = {
  statusPrefix?: string[];
  variableNames?: string[];
};
